"use client";
import { createContext, useEffect, useState } from "react";
import { FileMaker } from "./FileMaker";
import Spinner from "./Spinner";

// Create the context
const JWTCtx = createContext({
  JWT: "",
  setJWT: (JWT: string) => {},
  refreshToken: () => {},
});

// Create a provider component
export const JWTProvider = ({ children }: any) => {
  const [JWT, setJWT] = useState("");
  const [loadingToken, setLoadingToken] = useState(false);
  useEffect(() => {
    getToken();
  }, []);
  const getToken = async () => {
    setLoadingToken(true);
    try {
      console.log("JWTProvider: Attempting to get new JWT token...");
      const token = await new FileMaker(null).getToken();
      console.log("JWTProvider: Token obtained successfully:", token ? "Present" : "Missing");
      setJWT(token);
    } catch (error) {
      console.error("JWTProvider: Failed to get JWT token:", error);
      // Set a default empty token to prevent infinite loading
      setJWT("");
    } finally {
      setLoadingToken(false);
    }
  };

  const refreshToken = async () => {
    await getToken();
  };

  const context = { JWT, setJWT, refreshToken };
  return (
    <JWTCtx.Provider value={context}>
      {loadingToken && (
        <div className="flex flex-row gap-5 items-center">
          <Spinner />
          <p>Loading token...</p>
        </div>
      )}
      {children}
    </JWTCtx.Provider>
  );
};

export default JWTCtx;
